import React from 'react';
import { useEditMode } from './EditModeProvider';

const EditableText = ({ contentKey, defaultValue, tagName = 'span', className = '', style, ...props }) => {
  const { getContent } = useEditMode();
  const Tag = tagName;

  const currentText = getContent(contentKey, defaultValue);
  const currentColor = getContent(contentKey + '_color', '');

  const combinedStyle = { ...style };
  if (currentColor) {
      if (currentColor.includes('gradient')) {
          combinedStyle.backgroundImage = currentColor;
          combinedStyle.WebkitBackgroundClip = 'text';
          combinedStyle.WebkitTextFillColor = 'transparent';
          combinedStyle.backgroundClip = 'text';
      } else {
          combinedStyle.color = currentColor;
      }
  }

  return (
    <Tag
      style={combinedStyle}
      className={className}
      {...props}
    >
      {currentText}
    </Tag>
  );
};

export default EditableText;